export enum OperationModelType {
  CONFIG = "CONFIG",
  FIRM_UPDATE = "FIRM_UPDATE",
  OPTIONS = "OPTIONS",
  CERT_RENEW = "CERT_RENEW",
}
